export const apiVersion = 'v6';
//# sourceMappingURL=common.js.map